window.addEventListener("load", () => {

    let locationsMap; // Declare locationsMap variable outside the if block

    let locationData = document.getElementById("schooloverview-map-wrapper");

    const key = 'i9JxDqECb2BDFbg3Audp';

    if (locationData?.dataset?.locations) {
        // Custom icons
        var purpleIcon = L.icon({
            html: '<div id="blue-icon-content">I</div>',
            iconUrl: '/img/lvoscholen/icon-map-pointer-purple.svg',
            iconSize: [32, 32],
            iconAnchor: [16, 32],
        });

        var blueIcon = L.icon({
            html: '<div id="blue-icon-content">I</div>',
            iconUrl: '/img/lvoscholen/icon-map-pointer-blue.svg',
            iconSize: [32, 32],
            iconAnchor: [16, 32],
        });

        var pinkIcon = L.icon({
            html: '<div id="blue-icon-content">I</div>',
            iconUrl: '/img/lvoscholen/icon-map-pointer-pink.svg',
            iconSize: [32, 32],
            iconAnchor: [16, 32],
        });

        // Create map and set default view and zoom boundaries
        locationsMap = L.map('map_canvas').setView([51.19339, 5.988265], 9);
        L.tileLayer('https://api.maptiler.com/maps/streets-v2/{z}/{x}/{y}.png?key=' + key, {
            attribution: '&copy; <a href="https://www.openmaptiles.org/">OpenMapTiles</a>',
            minZoom: 9
        }).addTo(locationsMap);

        var clusterMarkers = L.markerClusterGroup({
            iconCreateFunction: function (cluster) {
                var markers = cluster.getAllChildMarkers();
                var count = markers.length;

                return L.divIcon({
                    html: '<div class="custom-cluster-count">' + count + '</div>',
                    className: 'custom-cluster-icon', // Add custom CSS class for styling the cluster icon
                    iconSize: [32, 32], // Set the size of the icon
                });
            },
            disableClusteringAtZoom: 15, //
        });

        // Generate ID for markers based on name+postalcode
        function generateUniqueID(name, postalCode) {
            const formattedName = name.replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
            const formattedPostalCode = postalCode.replace(/\s+/g, '-').toLowerCase();
            return `${formattedName}-${formattedPostalCode}`;
        }

        const locations = JSON.parse(locationData.dataset.locations);

        locations.forEach(function (location) {
            var markerIcon;

            location.id = generateUniqueID(location.name, location.postalCode);

            // Translate school type to matching icons
            switch (location.type) {
                case 'onze-scholen':
                    markerIcon = blueIcon;
                    break;
                case 'eerste-opvang-anderstaligen':
                    markerIcon = pinkIcon;
                    break;
                case 'ondersteunende-diensten':
                    markerIcon = purpleIcon;
                    break;
                default:
                    markerIcon = blueIcon; // Fallback icon
            }

            var marker = L.marker([location.lat, location.lng], { icon: markerIcon });

            // Set the id attribute of the marker's HTML element
            marker.on('add', function () {
                var markerElement = marker.getElement();
                if (markerElement) {
                    markerElement.id = location.id;
                }
            });

            // Create marker popup
            var popupContent = `
                <div class="location-popup-wrapper" id="${location.id}" style="width: 20rem;">
                    <h3 class="${location.type.replace(/\s+/g, '-').toLowerCase()}">
                     ${location.name}
                    </h3>
                    <div class="location-type">
                        ${location.type === 'onze-scholen' ? 'Onze scholen' :
                    location.type === 'eerste-opvang-anderstaligen' ? 'Eerste Opvang Anderstaligen' :
                        location.type === 'ondersteunende-diensten' ? 'Ondersteunende Diensten' : location.type
                }
                    </div>

                    <div class="location-address">
                        ${location.street} <br>
                        ${location.postalCode}, ${location.city}
                    </div>

                    <div class="location-photos">
                    ${location.logoUrl ? `<img class="location-logo" src="${location.logoUrl}" alt="${location.name} logo" />` : `<img class="location-image" src="${location.photoUrl}" alt="${location.name} locatie" />`}
                      
                    </div>
                </div>
            `;

            marker.bindPopup(popupContent);

            // Add cluster marker to map
            clusterMarkers.addLayer(marker); // Add the marker directly to the cluster group

            marker.on('click', function () {
                // Set the view to the marker's location
                locationsMap.setView([location.lat, location.lng], 15);

                // Open the popup after a short delay
                setTimeout(() => {
                    marker.openPopup();

                    // Extract the ID from the clicked marker
                    const markerId = this._icon.id;

                    // Find the marker's page
                    findItemPage(markerId);

                    // Find the matching item in the list
                    const locationsList = document.getElementById('locations-list');
                    const listItem = locationsList.querySelector(`#${markerId}`);

                    if (listItem) {
                        // Log the ID of the matching item

                        // Remove the 'active' class from all other sibling elements inside the <ul>
                        const listItems = locationsList.querySelectorAll('li');
                        listItems.forEach(item => {
                            if (item !== listItem) {
                                item.classList.remove('active');
                            }
                        });

                        // Add the 'active' class to the clicked list item
                        listItem.classList.add('active');
                    }

                    // Get the marker's LatLng coordinates
                    const markerLatLng = marker.getLatLng();

                    // Get the bounds of the marker and its popup
                    const bounds = L.latLngBounds([markerLatLng]);

                    // Include the popup's content in the bounds
                    if (marker.getPopup()) {
                        bounds.extend(marker.getPopup().getLatLng());
                    }

                    // Fit the bounds on the map with padding
                    locationsMap.fitBounds(bounds, { padding: [50, 50] });

                }, 300); // Adjust the delay as needed
            });


        });

        locationsMap.addLayer(clusterMarkers); // Add the MarkerClusterGroup to the map

        // After a short delay, invalidate the map size
        setTimeout(() => {
            locationsMap.invalidateSize();
        }, 100);
    }

    // Your existing code for handling paging functionality...
    const itemsPerPage = 5;
    const listItems = document.querySelectorAll('#locations-list li');
    const pagingNumberElement = document.getElementById('pagingNumber');
    const nextButton = document.getElementById('nextButton');
    const prevButton = document.getElementById('previousButton');

    let currentPage = 1;

    function findItemPage(itemId) {
        // Loop through each item in the list
        for (let i = 0; i < listItems.length; i++) {
            const currentItem = listItems[i];
            // Check if the item ID matches the target ID
            if (currentItem.id === itemId) {
                // Calculate the page containing the item
                showPage(Math.floor(i / itemsPerPage) + 1)
                return Math.floor(i / itemsPerPage) + 1;
            }
        }
        // Return -1 if the item is not found
        return -1;
    }

    if (listItems) {
        function showPage(pageNumber) {
            const startIdx = (pageNumber - 1) * itemsPerPage;
            const endIdx = startIdx + itemsPerPage;

            // Hide all items by default
            listItems.forEach(item => {
                item.style.display = 'none';
            });

            // Show the next set of items
            for (let i = startIdx; i < endIdx; i++) {
                if (listItems[i]) {
                    listItems[i].style.display = 'flex';
                }
            }

            // Update paging number
            if (pagingNumberElement) {
                pagingNumberElement.textContent = pageNumber + ' / ' + totalPages;
            }

            // Hide/show "Previous" and "Next" buttons
            if (prevButton && nextButton) {
                prevButton.style.display = pageNumber === 1 ? 'none' : 'block';
                nextButton.style.display = pageNumber === totalPages ? 'none' : 'block';
            }
        }

        function showNextItems() {
            currentPage++;
            showPage(currentPage);
        }

        function showPrevItems() {
            currentPage--;
            showPage(currentPage);
        }

        nextButton?.addEventListener('click', showNextItems);
        prevButton?.addEventListener('click', showPrevItems);

        // Calculate total number of pages
        const totalPages = Math.ceil(listItems.length / itemsPerPage);

        // Show the first set of items on load
        showPage(currentPage);
    }

    const locationsList = document.getElementById("locations-list");

    locationsList?.addEventListener("click", handleClick);

    function findClickedLIElement(targetElement) {
        // Traverse up the DOM hierarchy until you find the <li> or the #locations-list element
        while (targetElement !== null && targetElement.tagName !== "LI" && targetElement.id !== "locations-list") {
            targetElement = targetElement.parentNode;
        }

        return targetElement;
    }

    function handleClick(event) {
        // Find the closest <li> element or the <ul> (#locations-list) element
        const clickedLIElement = findClickedLIElement(event.target);

        if (clickedLIElement && clickedLIElement.tagName === "LI") {

            // Remove the "active" class from all <li> elements
            const allLIElements = document.querySelectorAll("#locations-list li");
            allLIElements.forEach(li => {
                li.classList.remove("active");
            });

            // Toggle the "active" class on the clicked <li> element
            clickedLIElement.classList.toggle("active");

            // Get the id attribute value and log it
            const idValue = clickedLIElement.id;

            // Get the "data-type-coordinates" attribute value
            const coordinatesValue = clickedLIElement.getAttribute("data-type-coordinates");

            // Split the coordinates
            const [latitude, longitude] = coordinatesValue.split(",")

            // Set the view and zoom level from the coordinates
            locationsMap.setView([latitude, longitude], 18, { animation: true });

            // Check if the screen is mobile
            const isMobile = window.innerWidth <= 768;

            if (isMobile) {
                // Scroll to #map_canvas on mobile screens
                const mapCanvas = document.querySelector("#map_canvas");
                if (mapCanvas) {
                    mapCanvas.scrollIntoView({ behavior: "smooth" });
                    document.querySelector("#map_canvas #" + idValue)?.click();
                }
            } else {
                // Click on the pointer to open the popup
                document.querySelector("#map_canvas #" + idValue)?.click();
            }
        }
    }

});
